import types from '@/store/types/Documentos'
import Vue from 'vue';

const state = {
    DocLegales: [],
    DocTecnicos: [],
    Documentos: [],
    UrlResolucion: String
}
const getters = {
    [types.getters.GetDocLegales]: (state) => {

        return state.DocLegales.map((data, index) => {
            data.ref = `refDropzone${index}`;
            data.files = [];
            return data;
        });
    },
    [types.getters.GetDocTecnicos]: (state) => {
        return state.DocTecnicos.map((data, index) => {
            data.ref = `refDropzone${index}`;
            data.files = [];
            return data;
        });
    },
    [types.getters.GetDocumentos]: (state) => {
        return state.Documentos.map((data, index) => {
            data.ref = `refDropzone${index}`;
            data.files = [];
            return data;
        });
    },
    [types.getters.GetUrlEnlace]:(state) => {
        return state.UrlResolucion
    }
}
const mutations = {
    [types.mutations.SetDocLegales]: (state, DocLegales) => {

        state.DocLegales = DocLegales;
    },
    [types.mutations.SetDocTecnicos]: (state, DocTecnicos) => {

        state.DocTecnicos = DocTecnicos;
    },
    [types.mutations.SetDocumentos]: (state, Documentos) => {

        state.Documentos = Documentos;
    },
    [types.mutations.SetUrlResolucion]: (state, UrlResolucion)=>{
        state.UrlResolucion = UrlResolucion
    }
}
const actions = {
    [types.actions.UrlResolucion]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.get(`pajel/resoluciones/enlace-resolucion`)
                .then(r => {
                  commit(types.mutations.SetUrlResolucion, r.data);
                    resolve(r);
                })
        })
    },
    [types.actions.TieneDocumentoYEstaNotificado]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.get(`pajel/ampliacion/net/ampliaciones/TieneDocumentoYEstaNotificado/${pObj.pTramiteId}/${pObj.pTipo}`)
                .then(r => {
                    resolve(r);
                })
        })
    },
    [types.actions.ListaDocumentos]: ({ commit }, pObj) => {
        commit(types.mutations.SetDocumentos, []);
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.get(`pajel/documento_pajel/list_solicitud/${pObj.solicitudId}/${pObj.criterio}`).then(r => {
                commit(types.mutations.SetDocumentos, r.data);
                resolve(r);
            })
        })
    },
    [types.actions.ListaDocumentosLegales]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.get(`pajel/documento_pajel/list_solicitud/${pObj.solicitudId}/DOCS_LEGALES_SOLICITUD_PAJEL_v2`).then(r => {
                commit(types.mutations.SetDocLegales, r.data);
                resolve(r);
            })
        })
    },
    [types.actions.ListaDocumentosTecnicos]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.get(`pajel/documento_pajel/list_solicitud/${pObj.solicitudId}/DOCS_TECNICOS_SOLICITUD_PAJEL_v2`).then(r => {
                commit(types.mutations.SetDocTecnicos, r.data);
                resolve(r);
            })
        })
    },
    [types.actions.ListaDocumentosDesistimiento]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.get(`pajel/documento_pajel/list_solicitud/${pObj.solicitudId}/DOCS_DESIST_RENUNCIA_SOLICITUD_PAJEL_v2`)
                .then(r => {
                    commit(types.mutations.SetDocumentos, r.data);
                    resolve(r);
                });
        });
    },
    [types.actions.ListaDocumentosDocsPosteriores]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.get(`pajel/documento_pajel/list_solicitud/${pObj.solicitudId}/DOCS_DOCS_POSTERIORES_SOLICITUD_PAJEL_v2`)
                .then(r => {
                    commit(types.mutations.SetDocumentos, r.data);
                    resolve(r);
                });
        });
    },
    [types.actions.ListaDocumentosOrdenFiscalizacion]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.get(`pajel/documento_pajel/list_solicitud/${pObj.solicitudId}/DOCS_DOCS_POSTERIORES_SOLICITUD_PAJEL_v2`)
                .then(r => {
                    commit(types.mutations.SetDocumentos, r.data);
                    resolve(r);
                });
        });
    },
    [types.actions.AdjuntarDocumentos]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.post(`pajel/documento_pajel/add`, pObj).then(r => {
                resolve(r);
            })
        })
    },

    [types.actions.SubirDocumentos]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.post(`pajel/documento_pajel/upload_archivo`, pObj).then(r => {
                resolve(r);
            })
        })
    },
    [types.actions.EliminarDocumentoPajel]: ({ commit }, idDocumento) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.delete(`pajel/documento_pajel/detalle/delete/${idDocumento}`).then(r => {
                resolve(r);
            })
        })
    },

    /*OBTENER RAM*/
    [types.actions.ObtenerRAM]: ({ commit }, pTramiteId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/documento_pajel/ampliacion_modificacion/download_file/${pTramiteId}`).then(r => {
                resolve(r);
            });
        });
    },

    /*OBTENER RAAI/RARI*/
    [types.actions.ObtenerRAAI]: ({ commit }, pTramiteId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/documento_pajel/ampliacion_modificacion/download_file/${pTramiteId}`).then(r => {
                resolve(r);
            });
        });
    },

    /*OBTENER AUTO*/
    [types.actions.ObtenerAUTO]: ({ commit }, pTramiteId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/documento_pajel/ampliacion_modificacion/download_file/${pTramiteId}`).then(r => {
                resolve(r);
            });
        });
    },


    /* OBTENCION DE RAA NEt */
    [types.actions.ObtenerRAA]: ({ commit }, pPromocionEmpresarialId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/documento_pajel/download_file/${pPromocionEmpresarialId}`).then(r => {
                resolve(r);
            });
        });
    },



    // OBTENCION DE PROVEIDO O AUTO NET
    [types.actions.ObtenerProveidoAutoDesistimiento]: ({ commit }, pTramiteId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/documento_pajel/desistimiento_renuncia/download_file/${pTramiteId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },

    // OBTENCION DE PROVEIDO O AUTO DOCS. POSTERIORES
    [types.actions.ObtenerProveidoAutoDocsPosteriores]: ({ commit }, pTramiteId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/documento_pajel/documentos_posteriores/download_file/${pTramiteId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },

    // OBTENCION DE PROVEIDO O AUTO PARA ORDEN DE FISCALIZACION
    [types.actions.ObtenerProveidoAutoOrdenFiscalizacion]: ({ commit }, pTramiteId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/documento_pajel/documentos_posteriores/download_file/${pTramiteId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },

    // OBTENER DOCUMENTO ADJUNTO PAJEL
    [types.actions.ObtenerDocumentoAdjunto]: ({ commit }, pNombreArchivo) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/documento_pajel/descargar_archivo?pNombreArchivo=${encodeURIComponent(pNombreArchivo)}`)
                .then(r => {
                    resolve(r);
                });
        });
    },

    // OBTENER DOCUMENTO ADJUNTO - ORDEN FISCALIZACION
    [types.actions.ObtenerDocumentoAdjuntoOrdenFiscalizacion]: ({ commit }, pDocumentoAdjuntoArchivoId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/orden_fiscalizacion/download/documento/${pDocumentoAdjuntoArchivoId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },

    //OBTENER PDF SOLICITUD AUTORIZACION DE PROMOCIONES EMPRESARIALES
    [types.actions.ObtenerDocumentoPDFSolicitudAutorizacion]: ({ commit }, pTramiteId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/promociones_empresariales/solicitudes/pdf/${pTramiteId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },
    //OBTENER PDF SOLICITUD AUTORIZACION DE PROMOCIONES EMPRESARIALES
    [types.actions.ObtenerDocumentoPDFSolicitudAmpliacionModificacion]: ({ commit }, pTramiteId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/promociones_empresariales/ampliacion/pdf/${pTramiteId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },

    //OBTENER FORM SOLICITUD DESISTIMIENTO RENUNCIA PE / AMPLIACIONES
    [types.actions.ObtenerFormSolicitudDesistimientoRenuncia]: ({ commit }, pSolicitudId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/promociones_empresariales/desestimiento_renuncia/pdf/${pSolicitudId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },

    //OBTENER PDF FORM SOLICITUD DOCUMENTOS POSTERIORES
    [types.actions.ObtenerFormSolicitudDocumentosPosteriores]: ({ commit }, pSolicitudId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/promociones_empresariales/documentos_posteriores/pdf/${pSolicitudId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },

    //OBTENER PDF FORM SOLICITUD PARA ORDEN DE FISCALIZACION
    [types.actions.ObtenerFormSolicitudOrdenFiscalizacion]: ({ commit }, pSolicitudId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/promociones_empresariales/orden_fiscalizacion/pdf/${pSolicitudId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },

    //OBTENER PDF FORM SOLICITUD DOCUMENTOS INCLUSION Y/O EXCLUSION
    [types.actions.ObtenerFormSolicitudInclusionExclusion]: ({ commit }, pTramiteId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/promociones_empresariales/inclusion_exclusion/pdf/${pTramiteId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },
    //OBTENER PDF FORM SOLICITUD ACLARACION COMPLEMENTACION ENMINEDA
    [types.actions.ObtenerFormSolicitudAclaracionComplEnmi]: ({ commit }, pTramiteId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/promociones_empresariales/aclaracion_complementacion_enmienda/pdf/${pTramiteId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },

    //OBTENER PLANTILLAS PAJEL
    [types.actions.ObtenerDocumentoAdjuntoPlantilla]: ({ commit }, pNombreArchivo) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/documento_pajel/descargarPlantilla/${pNombreArchivo}`)
                .then(r => {
                    resolve(r);
                });
        });
    },

    // VERIFICAR SI EXISTE NOTA O MEMORIAL REGISTRADO EN UNA SOLICITUD ID
    [types.actions.ExisteNotaMemorial]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.get(`pajel/documento_pajel/existe_nota_memorial/${pObj.solicitudId}`)
                .then(r => {
                    resolve(r);
                })
        })
    },

    // VERIFICAR SI EXISTE AL MENOS UN DOCUMENTO REGISTRADO EN UNA SOLICITUD ID
    [types.actions.TieneDocumentoAdjunto]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.get(`pajel/documento_pajel/tiene_documento_adjunto/${pObj.solicitudId}`)
                .then(r => {
                    resolve(r);
                })
        })
    },

    // VERIFICAR SI EXISTE AL MENOS UN DOCUMENTO REGISTRADO EN UNA SOLICITUD ID
    [types.actions.TieneDocumentoAdjuntoOFPE]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.get(`pajel/documento_pajel/tiene_documento_adjunto_ofpe/${pObj.solicitudId}`)
                .then(r => {
                    resolve(r);
                })
        })
    },

    //METODOS DE REMISION DE DOCUMENTOS
    [types.actions.ObtenerDocumentoRemisionDoc]: ({ commit }, pSolicitudId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.post(`pajel/documento_pajel/RemisionDocumento/listDocumentos/${pSolicitudId}`)
                .then(r => {
                    resolve(r);
                })
        })
    },
    [types.actions.ModificarDocumentoRemisionDoc]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.put(`pajel/documento_pajel/RemisionDocumento/update/${pObj.documentoAdjuntoId}`, pObj).then(r => {
                resolve(r);
            })
        })
    },
    [types.actions.EliminarDocDetalle]: ({ commit }, pDocumentoAdjuntoArchivoId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.delete(`pajel/documento_pajel/RemisionDocumento/eliminarDocumentoDetalle/${pDocumentoAdjuntoArchivoId}`).then(r => {
                resolve(r);
            })
        })
    },
    [types.actions.EliminarDocumento]: ({ commit }, pDocumentoAdjuntoId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.delete(`pajel/documento_pajel/delete/${pDocumentoAdjuntoId}`).then(r => {
                resolve(r);
            })
        })
    },
    [types.actions.SubirArchivoRemision]: ({ commit }, obj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.post(`pajel/documento_pajel/RemisionDocumento/upload_archivo`, obj).then(r => {
                resolve(r);
            })
        })
    },

    //OBTENER DOCUMENTO WORD DE LA DECLARACIÓN JURADA DE VERACIDAD
    [types.actions.ObtenerDocumentoWORDDeclaracionVeracidadSolAutoPe]: ({ commit }, obj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/promociones_empresariales/solicitud-autorizacion-pe/declaracion_veracidad/word/0/${obj.pPromocionEmpresarialNetId}/${obj.pPromocionEmpresarialId}/${obj.pSolicitudId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },
    [types.actions.ObtenerDocumentoWORDDeclaracionAnexoIISolAutoPe]: ({ commit }, obj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/promociones_empresariales/solicitud-autorizacion-pe/declaracion_anexo_ii/word/0/${obj.pPromocionEmpresarialNetId}/${obj.pPromocionEmpresarialId}/${obj.pSolicitudId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },
    [types.actions.ObtenerDocumentoWORDDeclaracionAnexoIIISolAutoPe]: ({ commit }, obj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/promociones_empresariales/solicitud-autorizacion-pe/declaracion_anexo_iii/word/0/${obj.pPromocionEmpresarialNetId}/${obj.pPromocionEmpresarialId}/${obj.pSolicitudId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },
    [types.actions.ObtenerDocumentoWORDDeclaracionVeracidadSolDocPost]: ({ commit }, obj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/promociones_empresariales/solicitud-documento-posterior/declaracion_veracidad/word/0/${obj.pPromocionEmpresarialNetId}/${obj.pPromocionEmpresarialId}/${obj.pSolicitudId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },

    [types.actions.ObtenerDocumentoWORDDeclaracionVeracidadSolDocPostFinal]: ({ commit }, obj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/promociones_empresariales/solicitud-documento-posterior/declaracion_veracidad_final/word/0/${obj.pPromocionEmpresarialNetId}/${obj.pPromocionEmpresarialId}/${obj.pSolicitudId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },


    //PARA REGISTRAR NUEVO DOCUMENTO
    [types.actions.AdherirDocumentoRemisionDoc]: ({ commit }, pObj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.post(`pajel/documento_pajel/add`, pObj).then(r => {
                resolve(r);
            })
        })
    },

    // VERIFICA SI HAY NUEVO AVISOOO
    [types.actions.existe_aviso]: ({ commit }, pOficinaId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.get(`pajel/documento_pajel/existe_aviso/${pOficinaId}`).then(r => {
                resolve(r);
            })
        })
    },
    //OBTENER PLANTILLAS PAJEL
    [types.actions.ObtenerDocumentoAdjuntoPlantillaV2]: ({ commit }, obj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/documento_pajel/descargarPlantillaV2/${obj.pNombreArchivo}/${obj.pSolicitudId}`)
                .then(r => {
                    resolve(r);
                });
        });
    },
    /* OBTENCION DE RAA NEt */
    [types.actions.DownloadFileByCiteID]: ({ commit }, pCiteId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/documento_pajel/download/cite/${pCiteId}`).then(r => {
                resolve(r);
            });
        });
    },
    //OBTENER PDF SOLICITUD AUTORIZACION DE PROMOCIONES EMPRESARIALES
    [types.actions.GenerarFormularioSolcitud]: ({ commit }, obj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/v3/solicitud/pdf/solicitudId/${obj.SolicitudId}/${obj.Tipo}`)
                .then(r => {
                    resolve(r);
                });
        });
    },
    [types.actions.GenerarFormularioTramite]: ({ commit }, obj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/reportes/v3/solicitud/pdf/tramiteId/${obj.TramiteId}/${obj.Tipo}`)
                .then(r => {
                    resolve(r);
                });
        });
    },
    [types.actions.GenerarFormularioV1]: ({ commit }, obj) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/pajelV1/solicitud/pdf/${obj.promocionId}/${obj.tramiteId}/${obj.tipo}`)
                .then(r => {
                    resolve(r);
                });
        });
    },
    // descarga adjunto para pajel V1
    [types.actions.DownloadFileByDocumentoId]: ({ commit }, pAdjuntoId) => {
        return new Promise((resolve, reject) => {
            Vue.prototype.$http.getFiles(`pajel/pajelV1/solicitud/downloadDocumentoFromPajelV1/${pAdjuntoId}`).then(r => {
                resolve(r);
            });
        });
    },
    // FIN OBTENER PDF SOLICITUD AUTORIZACION DE PROMOCIONES EMPRESARIALES

}
export default {
    state,
    actions,
    getters,
    mutations
}
